import { LayoutGrid, Table as TableIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
// ToggleGroup is NOT in the components/ui barrel — import from the module directly.
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import type { ServiceViewMode } from '@/hooks/use-services-view-mode';

interface ServicesViewToggleProps {
  mode: ServiceViewMode;
  onChange: (mode: ServiceViewMode) => void;
}

/**
 * Spec 352 §4: Kachel↔Tabelle view toggle. Cloned from preview-device-toggle —
 * a single-select ToggleGroup that swaps only the renderer, not the data.
 */
export function ServicesViewToggle({ mode, onChange }: ServicesViewToggleProps) {
  const { t } = useTranslation('services');
  return (
    <ToggleGroup
      type="single"
      value={mode}
      onValueChange={(value) => value && onChange(value as ServiceViewMode)}
      size="sm"
    >
      <ToggleGroupItem value="card" aria-label={t('view.card')}>
        <LayoutGrid className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="table" aria-label={t('view.table')}>
        <TableIcon className="h-4 w-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
